module.exports = __webpack_public_path__ + "img/fz-banner.1553bdab.png";